"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const graphql_1 = require("../../../graphql");
const hooks_1 = require("../hooks");
const hooks_2 = require("../../../hooks");
exports.EmailCanvasLoader = () => {
    const { pathParams, queryParams } = hooks_1.useEmailCanvasContext();
    const { featureFlags: { useNewLoaderForEmailQuery, includeDefaultContentFeedInEmailQuery, }, } = hooks_2.useOsmosysContext();
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(exports.EmailCanvasLoaderInner, { pathParams: pathParams, queryParams: queryParams, useNewLoaderForEmailQuery: useNewLoaderForEmailQuery, includeDefaultContentFeedInEmailQuery: includeDefaultContentFeedInEmailQuery })));
};
exports.EmailCanvasLoaderInner = ({ pathParams, queryParams, useNewLoaderForEmailQuery, includeDefaultContentFeedInEmailQuery, }) => {
    const createMode = !!(queryParams.template && queryParams.version);
    const variables = react_2.useMemo(() => {
        const emailNumber = parseInt(pathParams.emailNumber, 10);
        return {
            emailNumber,
            useNewLoaderFeature: useNewLoaderForEmailQuery,
        };
    }, [pathParams.emailNumber, useNewLoaderForEmailQuery]);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.OsmosysCanvasPageQueryLoader, { name: "email", query: graphql_1.email(includeDefaultContentFeedInEmailQuery), skip: createMode ||
                !pathParams.emailNumber ||
                pathParams.emailNumber === 'new', 
            // returnPartialData
            variables: variables })));
};
//# sourceMappingURL=index.js.map